module.exports = __webpack_public_path__ + "img/icons.661fa763.png";